import { Icon } from "@chakra-ui/react";
import { FaFileInvoice } from "react-icons/fa";
import {
  MdPerson,
  MdTrackChanges,
  MdManageAccounts,
  MdHistory,
  MdAdminPanelSettings,
  MdUpdate,
  MdSmartToy,
  MdBlock,
  MdAppBlocking,
} from "react-icons/md";
import AccountManager from "views/admin/accountManager";
import AppDetail from "views/admin/appDetail";
import AppTargeting from "views/admin/appTargeting";
import AppTargetingDetail from "views/admin/appTargeting/detail";

import Overview from "views/admin/default";
import GameChallenges from "views/admin/gameChallenges";
import GameNetworkExclusions from "views/admin/gameNetworkExclusions";
import Invoices from "views/admin/invoices";
import PartnerDetail from "views/admin/partnerDetail";
import Partners from "views/admin/partners";
import Tracking from "views/admin/tracking";
import AMUpdates from "views/admin/amUpdates";
import ChatbotPage from "views/admin/chatbot";
import InitialSetup from "views/admin/initialSetup";

// Auth Imports
import SignIn from "./views/auth/signIn";
import Terms from "./views/auth/terms";

const routes = [
  {
    name: "Partners",
    layout: "/",
    path: "/partners",
    icon: (
      <Icon
        as={MdManageAccounts}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: Partners,
  },
  {
    name: "Max AI",
    layout: "/",
    path: "/chatbot",
    icon: (
      <Icon
        as={MdSmartToy}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: ChatbotPage,
  },
  {
    name: "Change Log",
    layout: "/",
    path: "/change-log",
    icon: (
      <Icon
        as={MdHistory}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: Overview,
  },
  {
    name: "Tracking",
    layout: "/",
    path: "/tracking",
    icon: (
      <Icon
        as={MdTrackChanges}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: Tracking,
  },
  {
    name: "Invoices",
    layout: "/",
    path: "/invoices",
    icon: (
      <Icon
        as={FaFileInvoice}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: Invoices,
  },
  {
    name: "Accounts",
    layout: "/",
    path: "/accounts",
    icon: (
      <Icon
        as={MdAdminPanelSettings}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: AccountManager,
  },
  {
    name: "CRM",
    layout: "/",
    path: "/crm",
    icon: (
      <Icon
        as={MdUpdate}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: AMUpdates,
  },
  {
    name: "Network Exclusions",
    layout: "/",
    path: "/game-network-exclusions",
    icon: (
      <Icon
        as={MdBlock}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: GameNetworkExclusions,
  },
  {
    name: "App Targeting",
    layout: "/",
    path: "/app-targeting/:partnerId",
    icon: (
      <Icon
        as={MdAppBlocking}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: AppTargetingDetail,
    noSidebar: true,
  },
  {
    name: "App Targeting",
    layout: "/",
    path: "/app-targeting",
    icon: (
      <Icon
        as={MdAppBlocking}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: AppTargeting,
  },
  {
    name: "Game Challenge Configuration",
    layout: "/",
    path: "/partner/:partnerId/app/:appId/challenges",
    icon: (
      <Icon
        as={MdPerson}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: GameChallenges,
    noSidebar: true,
  },
  {
    name: "Initial Setup",
    layout: "/",
    path: "/partner/:partnerId/app/:appId/setup",
    icon: (
      <Icon
        as={MdPerson}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: InitialSetup,
    noSidebar: true,
  },
  {
    name: "Game Configuration",
    layout: "/",
    path: "/partner/:partnerId/app/:appId",
    icon: (
      <Icon
        as={MdPerson}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: AppDetail,
    noSidebar: true,
  },
  {
    name: "Partner Details",
    layout: "/",
    path: "/partner/:id",
    icon: (
      <Icon
        as={MdPerson}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: PartnerDetail,
    noSidebar: true,
  },
  /* {
		name: 'Events',
		layout: '/',
		path: '/events',
		icon: <Icon as={MdVideogameAsset} width='20px' height='20px' marginTop={0.5} color='inherit' />,
		component: Events
	}, */
  /* {
		name: 'Create Campaign',
		layout: '/',
		path: '/campaign/:id',
		icon: <Icon as={MdOutlineCampaign} width='20px' height='20px' marginTop={0.5} color='inherit' />,
		component: CampaignCreate,
	}, */
  /* {
		name: 'Account',
		layout: '/',
		path: '/account',
		icon: <Icon as={MdPerson} width='20px' height='20px' marginTop={0.5} color='inherit' />,
		component: Profile
	}, */
  {
    name: "Login",
    layout: "/auth",
    path: "/login",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: SignIn,
  },
  /* {
		name: 'Register',
		layout: '/auth',
		path: '/register',
		icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
		component: SignUp
	}, */
  {
    name: "Terms and Conditions",
    layout: "/auth",
    path: "/terms",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: Terms,
  },
];

export default routes;
